import { usePageScrollAreaHook } from '@/components/organisms/PageScrollArea/hook/usePageScrollAreaHook';
import styled, { css } from 'styled-components';

export const Content = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.tokens.colors.page_background};
  z-index: 999;
  display: flex;
  overflow-y: auto;

  ${() => {
    const { retornarValorMargemTopo } = usePageScrollAreaHook({
      isPageScrollArea: false,
    });

    return css`
      top: ${retornarValorMargemTopo('home')}px;
    `;
  }}
`;
